import { Button, Modal } from '@workspace/core-ts/components';
import { useSearchParams } from 'react-router-dom';

export default function ModalVehiculeL1Uniquement() {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <Modal
      className="sm:h-auto max-w-xl"
      onClose={() => {
        setSearchParams();
      }}
      open={searchParams.get('modal') === 'vehicule-l1-uniquement'}
      title="Véhicule de catégorie L1e uniquement"
      closeButton={false}
    >
      <Modal.Body className="pt-4 pb-8">
        <p className="text-sm">
          Véhicule à deux roues dont la vitesse maximale ne dépasse pas 45 km/h et équipé d'un moteur d'une cylindrée ne dépassant pas 50 cm³ ou d'une puissance
          maximale nette n'excédant pas 4 kilowatts si électrique
        </p>

        <Button
          className="mt-4"
          size="sm"
          arrow={false}
          onClick={() => setSearchParams()}
        >
          J'ai compris
        </Button>
      </Modal.Body>
    </Modal>
  );
}
